import React, { useMemo } from 'react';
import ModalNotificationComponent from '@ui/components/Modal-notification/Modal-notification.component';
import { IProps } from './IProps';

const Component: React.FC<IProps> = ({
    lang,
    confirmed,
    passwordConfirmed,
    confirmationErr,
    onClose,
}: IProps) => {
    const message = useMemo(() => {
        if (confirmed) return 'confirmSuccess';
        else if (passwordConfirmed) return 'confirmPasswordSuccess';
        else if (confirmationErr) return 'confirmationErr';
        else return '';
    }, [confirmed, passwordConfirmed, confirmationErr]);

    return (
        <ModalNotificationComponent
            lang={lang}
            message={message}
            onClose={onClose}
        />
    );
};

const ConfirmSuccessComponent = React.memo(Component);

export default ConfirmSuccessComponent;
